import { clientPath, LpBackendError, lpRequest } from '../../../../core/utils/lp-backend';
import { readSettings } from './settings-fields';

/**
 * cb replaced the list; `POST /client/:cid/settings/vehicle-types {vehicle_types, add}` adds or removes, so there is
 * one call per added and per removed type. A removed type also archives the client's vehicles of that type.
 */
export const editVehicleTypes = async (types: string[]): Promise<any> => {
  if (!types.length) {
    throw new LpBackendError('Keep at least one vehicle type.', 400);
  }
  const { vehicle_types: current } = await readSettings();
  const added = types.filter((type) => !current.includes(type));
  const removed = current.filter((type: string) => !types.includes(type));

  for (const type of added) {
    await lpRequest('POST', clientPath('/settings/vehicle-types'), {
      body: { vehicle_types: [type], add: true }
    });
  }
  for (const type of removed) {
    await lpRequest('POST', clientPath('/settings/vehicle-types'), {
      body: { vehicle_types: [type], add: false }
    });
  }

  return readSettings();
};
